import React from 'react';
import { Group, ThemeIcon, UnstyledButton, Text, Box } from '@good/ui/core';
import { Users, ChevronDown, ChevronUp } from '@good/icons';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_CONTENT_GROUP_HEIGHT } = rosterConfig;

interface ContentGroupHeaderProps {
  text: string;
  onClick: () => void;
  isOpen: boolean;
}

export function ColumnGroupHeader({ text, onClick = () => {}, isOpen = true }: ContentGroupHeaderProps) {
  return (
    <Box className='bordered-bottom bordered-right'>
      <UnstyledButton w='100%' h={TIMELINE_CONTENT_GROUP_HEIGHT} onClick={onClick} px='md' bg={rosterConfig.grayColor}>
        <Group wrap='nowrap' gap={4} justify='space-between'>
          <Group gap='xs'>
            <ThemeIcon variant='transparent' fz='sm' color='gray'>
              <Users />
            </ThemeIcon>
            <Text fw={550} size='sm'>
              {text}
            </Text>
          </Group>
          {isOpen ? (
            <ThemeIcon variant='transparent' fz='lg' color='gray'>
              <ChevronDown />
            </ThemeIcon>
          ) : (
            <ThemeIcon variant='transparent' fz='lg' color='gray'>
              <ChevronUp />
            </ThemeIcon>
          )}
        </Group>
      </UnstyledButton>
    </Box>
  );
}
